import { BigNumber } from '@ethersproject/bignumber'
import Trans from 'components/Trans'
import { VaultKey } from 'state/types'
import { ChainId } from '@abstra-dex/sdk'
import { CHAIN_ID } from './networks'
import { serializeTokens } from './tokens'
import { SerializedPoolConfig, PoolCategory } from './types'

const chainId = parseInt(CHAIN_ID, 10)
const { MAINNET } = ChainId

const serializedTokens = serializeTokens()

export const MAX_LOCK_DURATION = 31536000
export const UNLOCK_FREE_DURATION = 604800
export const ONE_WEEK_DEFAULT = 604800
export const BOOST_WEIGHT = BigNumber.from('10000000000000')
export const DURATION_FACTOR = BigNumber.from('31536000')

export const vaultPoolConfig = {
  [VaultKey.CakeVaultV1]: {
    name: <Trans>Auto ABS</Trans>,
    description: <Trans>Automatic restaking</Trans>,
    autoCompoundFrequency: 5000,
    gasLimit: 1000000,
    tokenImage: {
      primarySrc: `/images/toggle/abswap.png`,
      secondarySrc: '/images/tokens/autorenew.svg',
    },
  },
  [VaultKey.CakeVault]: {
    name: <Trans>Stake ABS</Trans>,
    description: <Trans>Stake, Earn – And more!</Trans>,
    autoCompoundFrequency: 5000,
    gasLimit: 1000000,
    tokenImage: {
      primarySrc: `/images/abstradex/svgs/logo.svg`,
      secondarySrc: '/images/tokens/autorenew.svg',
    },
  },
} as const

const pools: SerializedPoolConfig[] =
  chainId === MAINNET
    ? [
        // {
        //   sousId: 0,
        //   stakingToken: serializedTokens.cake,
        //   earningToken: serializedTokens.cake,
        //   contractAddress: {
        //     388: '0x9e1109725563f47539c11d3b840a9a687468083b',
        //     11124: '',
        //   },
        //   poolCategory: PoolCategory.CORE,
        //   harvest: true,
        //   tokenPerBlock: '3.25',
        //   sortOrder: 1,
        //   isFinished: false,
        // },
        // {
        //   sousId: 1,
        //   stakingToken: serializedTokens.weth,
        //   earningToken: serializedTokens.weth,
        //   contractAddress: {
        //     388: '0x2a3007cebf66405463d965a00e0dc1d536af1725',
        //     11124: '',
        //   },
        //   poolCategory: PoolCategory.CORE,
        //   harvest: true,
        //   tokenPerBlock: '0.004416',
        //   sortOrder: 1,
        //   isFinished: false,
        // },
        // {
        //   sousId: 3,
        //   stakingToken: serializedTokens.weth,
        //   earningToken: serializedTokens.weth,
        //   contractAddress: {
        //     388: '0x28ec609d4c1ba82cc7410473a8741f492dd99888',
        //     11124: '',
        //   },
        //   poolCategory: PoolCategory.CORE,
        //   harvest: true,
        //   tokenPerBlock: '0.004416',
        //   sortOrder: 2,
        //   isFinished: false,
        // },
        // {
        //   sousId: 2,
        //   stakingToken: serializedTokens.weth,
        //   earningToken: serializedTokens.cake,
        //   contractAddress: {
        //     388: '0x72d99fd1bd482586e82599ddaa68de1d187779b0',
        //     11124: '',
        //   },
        //   poolCategory: PoolCategory.CORE,
        //   harvest: true,
        //   tokenPerBlock: '0.02623',
        //   sortOrder: 3,
        //   isFinished: false,
        // },
      ]
    : [
        // {
        //   sousId: 0,
        //   stakingToken: serializedTokens.cake,
        //   earningToken: serializedTokens.cake,
        //   contractAddress: {
        //     388: '',
        //     11124: '0x87d80839E3d5D435D67346761C0a6c749Cb7A6a4',
        //   },
        //   poolCategory: PoolCategory.CORE,
        //   harvest: true,
        //   tokenPerBlock: '1',
        //   sortOrder: 1,
        //   isFinished: false,
        // },
        // {
        //   sousId: 1,
        //   stakingToken: serializedTokens.usdc,
        //   earningToken: serializedTokens.cake,
        //   contractAddress: {
        //     388: '',
        //     11124: '0x7aE4B7DA842d528d1AfBAF7Da9b820CC76863521',
        //   },
        //   poolCategory: PoolCategory.CORE,
        //   harvest: true,
        //   tokenPerBlock: '1',
        //   sortOrder: 1,
        //   isFinished: true,
        // },
        // {
        //   sousId: 2,
        //   stakingToken: serializedTokens.usdc,
        //   earningToken: serializedTokens.cake,
        //   contractAddress: {
        //     388: '',
        //     11124: '0xD229b6EC31a3eCF05D46F00F05aF63C759f52a09',
        //   },
        //   poolCategory: PoolCategory.CORE,
        //   harvest: true,
        //   tokenPerBlock: '0.072',
        //   sortOrder: 2,
        //   isFinished: true,
        // },
        // {
        //   sousId: 3,
        //   stakingToken: serializedTokens.usdc,
        //   earningToken: serializedTokens.cake,
        //   contractAddress: {
        //     388: '',
        //     11124: '0x77D66E223836f1b7D3cD928539ED919e5C2a4C99',
        //   },
        //   poolCategory: PoolCategory.CORE,
        //   harvest: true,
        //   tokenPerBlock: '0.072',
        //   sortOrder: 3,
        //   isFinished: false,
        // },
      ]
export default pools
